import { buildRunColumns } from "@/components/agents/agent-runs";
import { AgentNowAndQueue } from "@/components/agents/agent-work";
import { DataTable } from "@/components/ui/data-table";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

/** `/agents/$slug/activity`: what it does now and holds next beside every run it made, with its cost and outcome. */
export const Route = createFileRoute("/_app/agents/$slug/activity")({
  component: AgentActivity,
});

function AgentActivity() {
  const { t } = useTranslation();
  const data = useLoaderData({ from: "/_app/agents/$slug" });
  const { slug } = Route.useParams();
  return (
    <div className="grid items-start gap-4 xl:grid-cols-2">
      <AgentNowAndQueue slug={slug} />
      <section className="min-w-0 space-y-3 rounded-lg border bg-card p-5">
        <h2 className="font-bold font-heading text-xl">{t("agentWork.now.runs")}</h2>
        <div className="overflow-x-auto">
          <DataTable
            columns={buildRunColumns(t)}
            rows={data.runs}
            rowKey={(r) => r.id}
            rowTestId={() => "agent-run-row"}
            density="compact"
            emptyState={<span data-testid="runs-empty">{t("agents.activity.empty")}</span>}
          />
        </div>
      </section>
    </div>
  );
}
